export default "__VITE_ASSET__5f5f6afe__"